var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#cfdf47}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m748.2 917q-2.5 0-5.1-0.3-2.5-0.3-5-0.9-2.4-0.6-4.8-1.4-2.4-0.9-4.7-2.1l-217.6-113.9-217.6 113.9c-7.1 3.7-15 5.4-23 4.8-8-0.6-15.6-3.4-22-8.1-6.5-4.7-11.5-11.1-14.5-18.6-2.9-7.4-3.8-15.5-2.4-23.3l42.7-240.2-175.8-170.7c-2.7-2.7-5.1-5.8-7-9.2-1.9-3.3-3.3-6.9-4.2-10.7-1-3.7-1.4-7.5-1.3-11.4 0.1-3.9 0.7-7.7 1.8-11.4 1.3-3.7 3-7.3 5.2-10.6 2.3-3.3 4.9-6.3 8-8.8 3-2.6 6.4-4.7 10-6.3 3.6-1.6 7.5-2.7 11.4-3.3l243.2-35.4 107.1-218.9c3.5-7.2 8.9-13.3 15.7-17.5 6.8-4.3 14.7-6.5 22.7-6.5 8 0 15.9 2.2 22.7 6.5 6.8 4.2 12.2 10.3 15.7 17.5l108.4 218.5 243.2 35.4c3.9 0.6 7.7 1.7 11.4 3.3 3.6 1.6 7 3.7 10 6.3 3 2.5 5.7 5.5 7.9 8.8 2.3 3.3 4 6.8 5.2 10.6 1.2 3.7 1.8 7.5 1.9 11.4 0.1 3.8-0.3 7.7-1.3 11.4-0.9 3.8-2.4 7.4-4.3 10.7-1.9 3.4-4.2 6.4-6.9 9.2l-175.8 170.6 42.6 240.3c0.8 3.9 1 8 0.6 12-0.4 4.1-1.3 8-2.9 11.8-1.5 3.7-3.5 7.3-6 10.5-2.5 3.1-5.4 6-8.7 8.3q-2.9 2-6.1 3.6-3.1 1.5-6.5 2.5-3.4 0.9-6.9 1.3-3.5 0.5-7 0.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.01819ac51ebbc781942f67a69f9e7407.svg";
export { ForwardRef as ReactComponent };